import { Toast } from 'vant';

export interface RecomFace {
  ecommenderPhone: string;
  buyerName: string;
  buyerPhone: string;
  city: string;
  equipment: string;
}

export const verification = (value: RecomFace, checked: boolean) => {
  let str = false;
  // 定义正则表达式
  const reg = '0[1-9][0-9]{1,2}[-]?[1-9]\\d{6,7}|0[1-9][0-9]{1,2}\\s?[1-9][0-9]{6,7}|1[4356789]\\d{9}';
  // 创建正则表达式对象
  const regExp = new RegExp(reg);
  if (!value.ecommenderPhone) {
    Toast('请输入您的手机号码');
  } else if (!regExp.test(value.ecommenderPhone)) {
    Toast('请输入正确的手机号码');
  } else if (!value.buyerName) {
    Toast('请输入购机人的姓名');
  } else if (value.buyerName.length <= 1 || value.buyerName.length >= 8) {
    Toast('请输入正确的姓名');
  } else if (!value.buyerPhone) {
    Toast('请输入购机人手机号码');
  } else if (!regExp.test(value.buyerPhone)) {
    Toast('请输入正确购机人手机号码');
  } else if (!value.city) {
    Toast('请选择城市');
  } else if (!value.equipment) {
    Toast('请选择设备及型号');
  } else if (!checked) {
    Toast('请勾选用户协议');
  } else {
    str = true;
  }
  return str;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function GetRequest(name: any) {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  const r = window.location.search.substr(1).match(reg); //获取url中"?"符后的字符串并正则匹配
  let context = '';
  if (r) context = r[2];
  return context ? context : '';
}
